import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      boxSizing: 'border-box'
    },
    inputLabel: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontFamily: 'Inter, sans-serif',
      fontSize: '1rem',
      fontWeight: 500
    },

    /* Container que simula a borda externa */
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: '100%',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
      border: `1px solid ${isDark ? theme.palette.dark_stroke.main : theme.palette.gray_stroke.main}`,
      borderRadius: '8px',
      height: '25px',
      overflow: 'hidden',
      transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:focus-within': {
        borderColor: theme.palette.primary?.main || '#1976d2'
      }
    },
    disabled: {
      opacity: 0.6,
      pointerEvents: 'none'
    },

    /* Select na Esquerda */
    select: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px !important',
      paddingRight: '26px !important',
      backgroundColor: 'transparent !important',
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    flagContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px' // Espaço entre a bandeira e o DDI (+55)
    },
    countryCodeText: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontFamily: 'Inter, sans-serif',
      fontSize: '.875rem'
    },
    iconChevronDown: {
      color: theme.palette.blue_300.main,

      position: 'absolute',
      pointerEvents: 'none'
    },

    /* Divisor Central */
    divider: {
      width: '1px',
      minWidth: '1px',
      flexShrink: 0,
      height: '24px',
      backgroundColor: isDark
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main,
      margin: '0 4px'
    },

    /* Input na Direita */
    inputPhone: {
      flex: 1,
      width: '100%', // Faz o wrapper ocupar o espaço restante de forma fluida
      minWidth: 0,
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontFamily: 'Inter, sans-serif',
      fontSize: '.875rem',
      '& .MuiInputBase-root': {
        width: '100%' // Garante que a raiz do InputBase do MUI não quebre
      },
      '& input': {
        padding: '8px 0',
        width: '100%',
        boxSizing: 'border-box',
        letterSpacing: '0.5px',
        border: 'none !important', // Remove qualquer borda fantasma que o MUI tente injetar
        background: 'transparent !important',
        '&::placeholder': {
          color: isDark
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main,
          opacity: 1
        }
      }
    }
  }
})
